import Vue from 'vue'
import Vuex from 'vuex'
import { state, mutations } from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: state,
  mutations: mutations
})


// WEBPACK FOOTER //
// ./src/store/store.js